import router from "next/router";

import { canAccessClientStorage } from "./embed";
import { getFromLocalStorage, setInLocalStorage } from "./localStorage";

const REFRESH_COUNT_MAX = 3;

export const retryPageLoading = (): { willRefresh: boolean } => {
  const refreshCountStored = parseInt(getFromLocalStorage?.("page-has-been-force-refreshed") || "0");

  const refreshCount = isNaN(refreshCountStored) ? 0 : refreshCountStored;
  const incrementRefreshCount = refreshCount + 1;

  if (refreshCount < REFRESH_COUNT_MAX && canAccessClientStorage()) {
    setInLocalStorage?.("page-has-been-force-refreshed", incrementRefreshCount.toString());
    router.reload();
    return { willRefresh: true };
  } else {
    setInLocalStorage?.("page-has-been-force-refreshed", "0");
    return { willRefresh: false };
  }
};
